import store from "~/js/store/store";
export default class Gallery {
  constructor() {
    const contents = document.querySelector('._gallery');
    this.photo = document.querySelectorAll('._photo');
    this.thumbnail = document.querySelectorAll('._thumbnail');
    this.name = document.querySelector('._name');

    this.setup()
  }

  setup () {
    //初期にセットされる写真が0とは限らないのでcurrentを取得
    const currentPhotoNum = Array.from(this.thumbnail).findIndex(element => {
      return element.classList.contains('on');
    })
    if(currentPhotoNum !== false){
      store.dispatch('setPhotoNum', {
        num: currentPhotoNum
      });
      let target = this.thumbnail[currentPhotoNum];
      if(target != null && target.dataset.name){
        this.name.textContent = target.dataset.name;
      }else{
        this.name.textContent = "";
      }
    }

    this.thumbnail.forEach((elm, index) => {
      elm.addEventListener('click', (event) => {
        this.remove();
        let target = event.currentTarget;
        target.classList.add("on");
        if(target.dataset.name)
        {
          this.name.textContent = target.dataset.name;
        }
        else
        {
          this.name.textContent = "";
        }

        this.change(index);
      })
    });

    //一つ目の写真を選択
    //this.thumbnail[0].click();
  }

  remove() {
    this.photo.forEach((elm, index) => {
      elm.classList.remove("on");
    });
    this.thumbnail.forEach((elm, index) => {
      elm.classList.remove("on");
    });
  }

  change(index) {
    this.photo[index].classList.add("on");

    store.dispatch('setPhotoNum', {
      num: index
    });
  }

}